export interface Episode {
  no: string;
  title: string;
  synopsis: string;
  highlight?: boolean;
}

export interface Season {
  id: string;
  name: string;
  range: string;
  period: string;
  count: string;
  color: string;
  intro: string;
  cover: string;
  episodes: Episode[];
}

export const seasons: Season[] = [
  {
    id: "s1",
    name: "守护甜心！",
    range: "第 1-51 集",
    period: "2007 - 2008",
    count: "51 集",
    color: "rose",
    intro:
      "第一季是整个故事的起点。平凡却总被误认为冷酷的少女日奈森亚梦，在三颗守护蛋孵化后开启了成为『守护者 Joker』的旅程，也正式认识了复活社的阴谋与 X 蛋的秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20cute%20pink%20guardian%20egg%20with%20tiny%20wings%20and%20sparkles%2C%20rosy%20pink%20and%20cream%20gradient%20backdrop%2C%20floating%20hearts%20and%20soft%20bokeh%20lights%2C%20dreamy%20storybook%20art%2C%20clean%20centered%20composition%2C%20warm%20heartwarming%20tone&width=640&height=800&seq=season-s1-cover&orientation=portrait",
    episodes: [
      { no: "第1集", title: "守护甜心诞生！", synopsis: "亚梦还在睡梦中，三颗守护蛋悄然孵化，甜心小兰第一个破壳而出，亚梦的人生就此改变。", highlight: true },
      { no: "第2集", title: "心灵的蛋！", synopsis: "亚梦以 Joker 的身份加入圣夜学园守护者，开始了解守护蛋与守护甜心的世界。", highlight: true },
      { no: "第3集", title: "松松软软的牛奶！", synopsis: "面对校园里的传闻与误解，亚梦用甜心们的力量试着说出真实的心声。", highlight: true },
      { no: "第4集", title: "我要当榜样！", synopsis: "亚梦决心要成为更好的自己，却因为一味的逞强而渐渐迷失方向。", highlight: true },
      { no: "第5集", title: "和理想中的自己！", synopsis: "甜心们教导亚梦：真正的『理想的自己』，应该是忠于内心的模样。", highlight: true },
      { no: "第6集", title: "变色龙和雪地！", synopsis: "亚梦在滑雪场遇见神秘的少年几斗，一段若即若离的羁绊就此展开。", highlight: true },
      { no: "第7集", title: "小小的蛋！", synopsis: "守护者首次遭遇 X 蛋，亚梦明白了守护蛋背后隐藏的悲伤。", highlight: true },
      { no: "第8集", title: "樱色的变身！", synopsis: "喜欢绘画的甜心美琪登场，亚梦迎来了全新的变身与成长。", highlight: true },
      { no: "第9集", title: "歌呗的登场！", synopsis: "人气偶像歌呗以复活社歌手的身份登场，她的甜心们也暗藏着秘密。", highlight: true },
      { no: "第10集", title: "小丝的微笑！", synopsis: "温柔的甜心小丝出现，擅长家务与乐器的她带给亚梦更多温暖。", highlight: true },
      { no: "第11集", title: "温柔的内心！", synopsis: "亚梦尝试理解 X 蛋背后的真实心意，守护者第一次真正触及复活社的阴谋。", highlight: true },
      { no: "第12集", title: "忧郁的国王！", synopsis: "守护者们的首领——King 的忧世问题逐渐浮出水面，亚梦的成长面临新的考验。", highlight: true },
    ],
  },
  {
    id: "s2",
    name: "守护甜心！！心跳",
    range: "第 1-51 集",
    period: "2008 - 2009",
    count: "51 集",
    color: "mint",
    intro:
      "第二季继续展开守护蛋、X 蛋与复活社之间的纠葛。随着三角关系、几斗的身世与更多甜心加入，亚梦在守护与自我之间不断成长，剧情也从单元故事走向更完整的主线。",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20mint%20green%20guardian%20egg%20with%20tiny%20wings%20and%20glowing%20sparkles%2C%20soft%20mint%20and%20cream%20gradient%20backdrop%2C%20floating%20leaves%20and%20gentle%20light%2C%20dreamy%20storybook%20art%2C%20clean%20centered%20composition%2C%20fresh%20heartwarming%20tone&width=640&height=800&seq=season-s2-cover&orientation=portrait",
    episodes: [
      { no: "第1集", title: "心跳的开始！", synopsis: "新学期守护者重新集结，新的甜心与新的敌人开始登场，亚梦的心跳之旅再度出发。", highlight: true },
      { no: "第2集", title: "王子与守护蛋！", synopsis: "守护者们围绕新的守护蛋展开争夺，亚梦也逐渐看清自己真正的心意。", highlight: true },
      { no: "第3集", title: "心跳的旋律！", synopsis: "歌呗与亚梦的关系出现转机，音乐与羁绊在紧张的气氛中悄悄升温。", highlight: true },
      { no: "第4集", title: "迷路的小甜心！", synopsis: "一只迷路的甜心帮助亚梦重新审视守护蛋存在的意义。", highlight: true },
      { no: "第5集", title: "三角关系的风暴！", synopsis: "亚梦、唯世与几斗之间的三角关系越发明朗，亚梦陷入甜蜜又烦恼的抉择。", highlight: true },
      { no: "第6集", title: "几斗的秘密！", synopsis: "几斗的身世逐渐揭开，守护者第一次了解到复活社背后的黑暗历史。", highlight: true },
      { no: "第7集", title: "守护蛋的考验！", synopsis: "守护蛋们面临是否孵化的抉择，亚梦在守护他人的同时学会了守护自己。", highlight: true },
      { no: "第8集", title: "勇气与真心！", synopsis: "面对一次重大危机，亚梦明白了真正的勇气来自敢于直面自己的内心。", highlight: true },
      { no: "第9集", title: "甜心的告别？", synopsis: "当守护蛋完成使命后，或许终将离去——亚梦开始思考甜心们的未来。", highlight: true },
      { no: "第10集", title: "心跳的最终章！", synopsis: "主线冲突全面爆发，守护者与复活社的决战一触即发。", highlight: true },
      { no: "第11集", title: "重生的守护蛋！", synopsis: "经历重重考验后，新的守护蛋破壳而出，带来全新的希望与力量。", highlight: true },
      { no: "第12集", title: "向着未来！", synopsis: "第一部的故事暂时告一段落，亚梦与甜心们迎向更加广阔的未来。", highlight: true },
    ],
  },
  {
    id: "s3",
    name: "守护甜心！派对",
    range: "第 1-25 集",
    period: "2009 - 2010",
    count: "25 集",
    color: "amber",
    intro:
      "第三部采用动画与真人秀结合的形式，动画部分聚焦守护蛋与甜心们的全新故事，真人环节则记录声优与角色的派对日常，是守护甜心系列温暖的收尾篇。",
    cover:
      "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20illustration%20of%20a%20warm%20golden%20guardian%20egg%20with%20tiny%20wings%20and%20party%20confetti%20sparkles%2C%20soft%20amber%20and%20cream%20gradient%20backdrop%2C%20floating%20stars%20and%20confetti%2C%20dreamy%20festive%20storybook%20art%2C%20clean%20centered%20composition%2C%20warm%20joyful%20tone&width=640&height=800&seq=season-s3-cover&orientation=portrait",
    episodes: [
      { no: "第1集", title: "派对开始！", synopsis: "守护甜心系列以全新的派对形式登场，甜心们与角色们迎来欢乐的日常新篇。", highlight: true },
      { no: "第2集", title: "甜心的新冒险！", synopsis: "动画部分展开守护蛋的全新冒险，甜心们各自追逐着新的梦想。", highlight: true },
      { no: "第3集", title: "许愿的守护蛋！", synopsis: "一枚许愿守护蛋的出现，让守护者们重新思考『心愿』与『真心』的含义。", highlight: true },
      { no: "第4集", title: "回忆的旋律！", synopsis: "歌呗在派对中献上熟悉的旋律，唤起守护者们的珍贵回忆。", highlight: true },
      { no: "第5集", title: "甜心的家园！", synopsis: "守护蛋与甜心的世界里，也藏着一个个等待被理解的温柔故事。", highlight: true },
      { no: "第6集", title: "新的守护者！", synopsis: "新成员的加入为守护者带来活力，也带来关于成长的新课题。", highlight: true },
      { no: "第7集", title: "星空下的约定！", synopsis: "守护者们在星空下许下约定，亚梦的心意也变得更加坚定。", highlight: true },
      { no: "第8集", title: "献给未来的歌！", synopsis: "派对临近尾声，亚梦与甜心们用歌声与笑容为这段旅程画上温暖的句点。", highlight: true },
    ],
  },
];

export const featuredEpisodes = [
  { seasonId: "s1", episodeNo: "第1集", title: "守护甜心诞生！", season: "守护甜心！", synopsis: "三颗守护蛋孵化，甜心小兰登场，亚梦的守护者之旅从这里开始。" },
  { seasonId: "s1", episodeNo: "第25集", title: "无限大！", season: "守护甜心！", synopsis: "第一季最经典的燃点之一，亚梦直面内心，力量与勇气一同升华。" },
  { seasonId: "s2", episodeNo: "第51集", title: "心跳的最终回！", season: "守护甜心！！心跳", synopsis: "第二季主线收束，守护者与复活社的纠葛迎来阶段性落幕。" },
  { seasonId: "s3", episodeNo: "第8集", title: "献给未来的歌！", season: "守护甜心！派对", synopsis: "系列完结篇，甜心们用歌声与笑容告别，为整个故事画上句点。" },
];